import DownloadFileButton from './DownloadFileButton';

export default DownloadFileButton;
